export const VIDEO_ALERT_GET_EVENT_MEDIA = "VIDEO_ALERT_GET_EVENT_MEDIA";
export const VIDEO_ALERT_GET_EVENT_MEDIA_RESPONSE = "VIDEO_ALERT_GET_EVENT_MEDIA_RESPONSE";